import store, { modules } from '../store/index';
import ScreenUrl from './url';
import TheLoginPageLayout from '../components/templates/TheLoginPageLayout.vue';
import TheLoginWaitingPageLayout from '../components/templates/TheLoginWaitingPageLayout.vue';
import TheNodeSamlLoginPageLayout from '../components/templates/TheNodeSamlLoginPageLayout.vue';
import TheNodeSamlPageLayout from '../components/templates/TheNodeSamlPageLayout.vue';
import TheNodeSamlBeforePageLayout from '../components/templates/TheNodeSamlBeforePageLayout.vue';
import TheSamlLoginWaitingPage from '../components/pages/auth/TheSamlLoginWaitingPage.vue';
import TheSamlVerifyPage from '../components/pages/auth/TheSamlVerifyPage.vue';
import TheNodeSamlLoginPage from '../components/pages/auth/TheNodeSamlLoginPage.vue';
import ThePageLayout from '../components/templates/ThePageLayout.vue';
import TheHomePage from '../components/pages/home/TheHomePage.vue';
import TheLoginPage from '../components/pages/auth/TheLoginPage.vue';
import TheChangePasswordPage from '../components/pages/auth/TheChangePasswordPage.vue';

// ユーザー管理系
const TheUserListPage = () => import(/* webpackChunkName: "user" */ '../components/pages/user/TheUserListPage.vue');
const TheUserDetailsPage = () =>
    import(/* webpackChunkName: "user" */ '../components/pages/user/TheUserDetailsPage.vue');
const TheUserGroupListPage = () =>
    import(/* webpackChunkName: "user" */ '../components/pages/user_group/TheUserGroupListPage.vue');
const TheUserGroupDetailsPage = () =>
    import(/* webpackChunkName: "user" */ '../components/pages/user_group/TheUserGroupDetailsPage.vue');
const TheUserInformation = () =>
    import(/* webpackChunkName: "user" */ '../components/organisms/user/TheUserInformation.vue');

// ノード系
const TheNodeListPage = () => import(/* webpackChunkName: "node" */ '../components/pages/node/TheNodeListPage.vue');
const TheNodeDetailsPage = () =>
    import(/* webpackChunkName: "node" */ '../components/pages/node/TheNodeDetailsPage.vue');

// ノードドメイン系
const TheNodeDomainListPage = () =>
    import(/* webpackChunkName: "node-domain" */ '../components/pages/node_domain/TheNodeDomainListPage.vue');
const TheNodeDomainDetailsPage = () =>
    import(/* webpackChunkName: "node-domain" */ '../components/pages/node_domain/TheNodeDomainDetailsPage.vue');

// ノードIdP系
const TheNodeIdpListPage = () =>
    import(/* webpackChunkName: "node-idp" */ '../components/pages/node_idp/TheNodeIdpListPage.vue');
const TheNodeIdpDetailsPage = () =>
    import(/* webpackChunkName: "node-idp" */ '../components/pages/node_idp/TheNodeIdpDetailsPage.vue');

// ノードグループ
const TheNodeGroupListPage = () =>
    import(/* webpackChunkName: "node-group" */ '../components/pages/node_group/TheNodeGroupListPage.vue');
const TheNodeGroupDetailsPage = () =>
    import(/* webpackChunkName: "node-group" */ '../components/pages/node_group/TheNodeGroupDetailsPage.vue');

// ドメインアカウント系
const TheDomainAccountDetailsPage = () =>
    import(
        /* webpackChunkName: "domain-account" */ '../components/pages/node_domain/domain_account/TheDomainAccountDetailsPage.vue'
    );
const TheDomainAccountRegistPage = () =>
    import(
        /* webpackChunkName: "domain-account" */ '../components/pages/node_domain/domain_account/TheDomainAccountRegistPage.vue'
    );

// IdPアカウント系
const TheIdpAccountDetailsPage = () =>
    import(
        /* webpackChunkName: "idp-account" */ '../components/pages/node_idp/idp_account/TheIdpAccountDetailsPage.vue'
    );
const TheIdpAccountRegisterPage = () =>
    import(
        /* webpackChunkName: "idp-account" */ '../components/pages/node_idp/idp_account/TheIdpAccountRegisterPage.vue'
    );

// OSアカウント系
const TheOsAccountAdditionalPage = () =>
    import(/* webpackChunkName: "os-account" */ '../components/pages/node/os_account/TheOsAccountAdditionalPage.vue');
const TheOsAccountDetailsPage = () =>
    import(/* webpackChunkName: "os-account" */ '../components/pages/node/os_account/TheOsAccountDetailsPage.vue');

// その他アカウント系
const TheOtherAccountAdditionalPage = () =>
    import(
        /* webpackChunkName: "other-account" */ '../components/pages/node/other_account/TheOtherAccountAdditionalPage.vue'
    );
const TheOtherAccountDetailsPage = () =>
    import(
        /* webpackChunkName: "other-account" */ '../components/pages/node/other_account/TheOtherAccountDetailsPage.vue'
    );

// システム設定系
const TheMailSettingPage = () =>
    import(/* webpackChunkName: "setting" */ '../components/pages/sys_pre/TheMailSettingPage.vue');
const TheServerSettingPage = () =>
    import(/* webpackChunkName: "setting" */ '../components/pages/sys_pre/TheServerSettingPage.vue');
const TheUserAuthenticateManagementPage = () =>
    import(/* webpackChunkName: "setting" */ '../components/pages/sys_pre/TheUserAuthenticateManagementPage.vue');
const ThePrivilegedIdSettingPage = () =>
    import(
        /* webpackChunkName: "setting" */ '../components/pages/privileged_id_setting/ThePrivilegedIdSettingPage.vue'
    );
const ThePersonalSettingPage = () =>
    import(/* webpackChunkName: "setting" */ '../components/pages/personal_setting/ThePersonalSettingPage.vue');
const TheRecLinkageSettingPage = () =>
    import(/* webpackChunkName: "setting" */ '../components/pages/rec_linkage_setting/TheRecLinkageSettingPage.vue');

// システム変更履歴系
const TheSystemChangeHistoryListPage = () =>
    import(
        /* webpackChunkName: "system-change-history" */ '../components/pages/system_change_history/TheSystemChangeHistoryListPage.vue'
    );

// 検知ルール管理系
const TheDetectionRuleDetailsPage = () =>
    import(
        /* webpackChunkName: "detection-rule" */ '../components/pages/detection_rule/TheDetectionRuleDetailsPage.vue'
    );
const TheDetectionRuleListPage = () =>
    import(/* webpackChunkName: "detection-rule" */ '../components/pages/detection_rule/TheDetectionRuleListPage.vue');
const TheDetectionRuleGroupDetailsPage = () =>
    import(
        /* webpackChunkName: "detection-rule" */ '../components/pages/detection_rule_group/TheDetectionRuleGroupDetailsPage.vue'
    );
const TheDetectionRuleGroupListPage = () =>
    import(
        /* webpackChunkName: "detection-rule" */ '../components/pages/detection_rule_group/TheDetectionRuleGroupListPage.vue'
    );

// ワークフロー系
const TheWorkflowDetailsPage = () =>
    import(/* webpackChunkName: "workflow" */ '../components/pages/workflow/TheWorkflowDetailsPage.vue');
const TheWorkflowListPage = () =>
    import(/* webpackChunkName: "workflow" */ '../components/pages/workflow/TheWorkflowListPage.vue');

// ジョブ実行系
const TheJobExecutionDetailsPage = () =>
    import(
        /* webpackChunkName: "job-execution-history" */ '../components/pages/job_execution_history/TheJobExecutionDetailsPage.vue'
    );
const TheJobExecutionHistoryListPage = () =>
    import(
        /* webpackChunkName: "job-execution-history" */ '../components/pages/job_execution_history/TheJobExecutionHistoryListPage.vue'
    );

// 多要素認証デバイス管理系
const TheMultifactorAuthenticationDetailsPage = () =>
    import(
        /* webpackChunkName: "multifactor-auth" */ '../components/pages/multifactor_auth/TheMultifactorAuthenticationDetailsPage.vue'
    );
const TheMultifactorAuthenticationListPage = () =>
    import(
        /* webpackChunkName: "multifactor-auth" */ '../components/pages/multifactor_auth/TheMultifactorAuthenticationListPage.vue'
    );

// 自動ログインアプリ定義管理系
const TheAutoLoginApplicationDetailsPage = () =>
    import(
        /* webpackChunkName: "auto-login-app" */ '../components/pages/auto_login_app/TheAutoLoginApplicationDetailsPage.vue'
    );
const TheAutoLoginApplicationListPage = () =>
    import(
        /* webpackChunkName: "auto-login-app" */ '../components/pages/auto_login_app/TheAutoLoginApplicationListPage.vue'
    );

// 業務システム系
const TheBusinessSystemDetailsPage = () =>
    import(
        /* webpackChunkName: "business-system" */ '../components/pages/business_system/TheBusinessSystemDetailsPage.vue'
    );
const TheBusinessSystemListPage = () =>
    import(
        /* webpackChunkName: "business-system" */ '../components/pages/business_system/TheBusinessSystemListPage.vue'
    );

// 業務系
const TheAccountSetDetailsPage = () =>
    import(
        /* webpackChunkName: "business-system" */ '../components/pages/business_system/account_set/TheAccountSetDetailsPage.vue'
    );
const TheAccountSetAdditionalPage = () =>
    import(
        /* webpackChunkName: "business-system" */ '../components/pages/business_system/account_set/TheAccountSetAdditionalPage.vue'
    );

// 申請書テンプレート
const TheApplicationTemplateDetailsPage = () =>
    import(
        /* webpackChunkName: "application-template" */ '../components/pages/business_system/application_template/TheApplicationTemplateDetailsPage.vue'
    );
const TheApplicationTemplateAdditionalPage = () =>
    import(
        /* webpackChunkName: "application-template" */ '../components/pages/business_system/application_template/TheApplicationTemplateAdditionalPage.vue'
    );

// 定常作業テンプレート
const TheRoutineWorkTemplateAdditionalPage = () =>
    import(
        /* webpackChunkName: "routine-work-template" */ '../components/pages/business_system/routine_work_template/TheRoutineWorkTemplateAdditionalPage.vue'
    );
const TheRoutineWorkTemplateDetailsPage = () =>
    import(
        /* webpackChunkName: "routine-work-template" */ '../components/pages/business_system/routine_work_template/TheRoutineWorkTemplateDetailsPage.vue'
    );

// 申請系
const TheDetailsApplicationFormAdditionalPage = () =>
    import(
        /* webpackChunkName: "work-application" */ '../components/pages/application_form/TheDetailsApplicationFormAdditionalPage.vue'
    );
const TheSimpleApplicationFormAdditionalPage = () =>
    import(
        /* webpackChunkName: "work-application" */ '../components/pages/application_form/TheSimpleApplicationFormAdditionalPage.vue'
    );
const TheCopyApplicationFormAdditionalPage = () =>
    import(
        /* webpackChunkName: "work-application" */ '../components/pages/application_form/TheCopyApplicationFormAdditionalPage.vue'
    );
const TheApplicationFormTemplateListPage = () =>
    import(
        /* webpackChunkName: "work-application" */ '../components/pages/application_form_template/TheApplicationFormTemplateListPage.vue'
    );
const TheWaitingApplicationListPage = () =>
    import(
        /* webpackChunkName: "work-application" */ '../components/pages/waiting_application/TheWaitingApplicationListPage.vue'
    );
const TheWaitingDetailsApplicationFormAdditionalPage = () =>
    import(
        /* webpackChunkName: "work-application" */ '../components/pages/waiting_application/TheWaitingDetailsApplicationFormAdditionalPage.vue'
    );

// 申請書系
const TheApplicationFormDetailsPage = () =>
    import(
        /* webpackChunkName: "application-form" */ '../components/pages/application_form/TheApplicationFormDetailsPage.vue'
    );
const TheApplicationFormListPage = () =>
    import(
        /* webpackChunkName: "application-form" */ '../components/pages/application_form/TheApplicationFormListPage.vue'
    );

// 特権ID管理系
const TheLendingRecordListPage = () =>
    import(
        /* webpackChunkName: "privilege-id-lending-record" */ '../components/pages/application_form/lending_record/TheLendingRecordListPage.vue'
    );
const ThePrivilegeIdLendingHistoryDetailsPage = () =>
    import(
        /* webpackChunkName: "privilege-id-lending-record" */ '../components/pages/privilege_id_lending_record/ThePrivilegeIdLendingHistoryDetailsPage.vue'
    );
const ThePrivilegeIdLendingHistoryPage = () =>
    import(
        /* webpackChunkName: "privilege-id-lending-record" */ '../components/pages/privilege_id_lending_record/ThePrivilegeIdLendingHistoryPage.vue'
    );

// 検知記録系
const TheApplicationFormDetectionRulesRecordListPage = () =>
    import(
        /* webpackChunkName: "detection-rules-record" */ '../components/pages/application_form/TheDetectionRulesRecordListPage.vue'
    );
const TheDetectionRulesRecordDetailsPage = () =>
    import(
        /* webpackChunkName: "detection-rules-record" */ '../components/pages/detection_rules_record/TheDetectionRulesRecordDetailsPage.vue'
    );
const TheDetectionRulesRecordListPage = () =>
    import(
        /* webpackChunkName: "detection-rules-record" */ '../components/pages/detection_rules_record/TheDetectionRulesRecordListPage.vue'
    );

// ノードログイン履歴系
const TheLoginHistoryPage = () =>
    import(/* webpackChunkName: "login-history" */ '../components/pages/login_record/TheLoginHistoryPage.vue');

// ノードログイン失敗履歴系
const TheLoginFailureHistoryPage = () =>
    import(
        /* webpackChunkName: "login-failure-history" */ '../components/pages/login_failure_record/TheLoginFailureHistoryPage.vue'
    );

// ライセンス系
const TheLicenseListPage = () =>
    import(/* webpackChunkName: "license" */ '../components/pages/license/TheLicenseListPage.vue');
const TheLicenseDetailsPage = () =>
    import(/* webpackChunkName: "license" */ '../components/pages/license/TheLicenseDetailsPage.vue');

// CSV系
const TheCsvListPage = () => import(/* webpackChunkName: "csv" */ '../components/pages/csv/TheCsvListPage.vue');

// 外部プログラム利用情報
const TheExternalProgramUsageDetailsPage = () =>
    import(
        /* webpackChunkName: "externalProgramUsage" */ '../components/pages/external_program_usage/TheExternalProgramUsageDetailsPage.vue'
    );
const TheExtarnalProgramUsageListPage = () =>
    import(
        /* webpackChunkName: "externalProgramUsage" */ '../components/pages/external_program_usage/TheExternalProgramUsageListPage.vue'
    );

// ログイン履歴収集除外条件
const TheNodeLoginHistoryExcludeConditionListPage = () =>
    import(
        /* webpackChunkName: "nodeLoginHistoryExcludeCondition" */ '../components/pages/node_login_history_exclude_condition/TheNodeLoginHistoryExcludeConditionListPage.vue'
    );
const TheNodeLoginHistoryExcludeConditionDetailsPage = () =>
    import(
        /* webpackChunkName: "nodeLoginHistoryExcludeCondition" */ '../components/pages/node_login_history_exclude_condition/TheNodeLoginHistoryExcludeConditionDetailsPage.vue'
    );

// アカウント棚卸結果差分
const TheAccountInventoryResultDiffListPage = () =>
    import(
        /* webpackChunkName: "account-inventory-result-diff" */ '../components/pages/account_inventory_result_diff/TheAccountInventoryResultDiffListPage.vue'
    );
const TheAccountInventoryResultDiffDetailsPage = () =>
    import(
        /* webpackChunkName: "account-inventory-result-diff" */ '../components/pages/account_inventory_result_diff/TheAccountInventoryResultDiffDetailsPage.vue'
    );

// アカウント棚卸設定
const TheAccountInventorySettingDetailsPage = () =>
    import(
        /* webpackChunkName: "account-inventory-setting" */ '../components/pages/account_inventory_setting/TheAccountInventorySettingDetailsPage.vue'
    );
const TheAccountInventorySettingListPage = () =>
    import(
        /* webpackChunkName: "account-inventory-setting" */ '../components/pages/account_inventory_setting/TheAccountInventorySettingListPage.vue'
    );

// アカウント棚卸結果
const TheAccountInventoryResultListPage = () =>
    import(
        /* webpackChunkName: "account-inventory-result" */ '../components/pages/account_inventory_result/TheAccountInventoryResultListPage.vue'
    );
const TheAccountInventoryResultDetailsPage = () =>
    import(
        /* webpackChunkName: "account-inventory-result" */ '../components/pages/account_inventory_result/TheAccountInventoryResultDetailsPage.vue'
    );

// ノードSAML連携ログイン
const TheNodeSamlWorkListPage = () =>
    import(/* webpackChunkName: "node_saml" */ '../components/pages/node_saml/TheNodeSamlWorkListPage.vue');
const TheNodeSamlBeforeWorkListPage = () =>
    import(/* webpackChunkName: "node_saml" */ '../components/pages/node_saml/TheNodeSamlBeforeWorkListPage.vue');
const TheNodeSamlWorkListErrorPage = () =>
    import(/* webpackChunkName: "node_saml" */ '../components/pages/node_saml/TheNodeSamlWorkListErrorPage.vue');

const routes: Object = {
    mode: 'history',
    routes: [
        {
            path: ScreenUrl.Auth.LOGIN,
            component: TheLoginPageLayout,
            children: [
                {
                    path: ScreenUrl.Auth.LOGIN,
                    name: 'Login Page',
                    component: TheLoginPage,
                    meta: { requiresBeforeAuth: true },
                },
                {
                    path: ScreenUrl.Auth.PASSWORD_CHANGE,
                    name: 'Password Change Page',
                    component: TheChangePasswordPage,
                    meta: { passwordChange: true },
                    props: true,
                },
            ],
        },
        {
            path: ScreenUrl.TOP,
            component: ThePageLayout,
            meta: { requiresAuth: true },
            children: [
                {
                    path: ScreenUrl.TOP,
                    name: 'Home',
                    component: TheHomePage,
                },
                {
                    path: ScreenUrl.User.INDEX,
                    name: 'User List',
                    component: TheUserListPage,
                    meta: { can: 'search User' },
                },
                {
                    path: ScreenUrl.User.SHOW,
                    name: 'User Details',
                    component: TheUserDetailsPage,
                    meta: {
                        can: async (to, from, can) => {
                            const pageUser = { id: Number(to.params.id) };
                            return can('show', 'User', pageUser);
                        },
                    },
                },
                {
                    path: ScreenUrl.User.ACCESS_KEYS,
                    name: 'User Access Key List',
                    component: TheUserInformation,
                    meta: {
                        can: (to, from, can) => {
                            const pageUser = { id: Number(to.params.id) };
                            return can('access_keys', 'User', pageUser);
                        },
                    },
                },
                {
                    path: ScreenUrl.UserGroup.INDEX,
                    name: 'User Group List',
                    component: TheUserGroupListPage,
                    meta: { can: 'search UserGroup' },
                },
                {
                    path: ScreenUrl.UserGroup.SHOW,
                    name: 'User Group Details',
                    component: TheUserGroupDetailsPage,
                    meta: { can: 'show UserGroup' },
                },
                {
                    path: ScreenUrl.NodeDomain.INDEX,
                    name: 'Node Domain List',
                    component: TheNodeDomainListPage,
                    meta: { can: 'search NodeDomain' },
                },
                {
                    path: ScreenUrl.NodeDomain.SHOW,
                    name: 'Node Domain Details',
                    component: TheNodeDomainDetailsPage,
                    meta: { can: 'show NodeDomain' },
                },
                {
                    path: ScreenUrl.NodeDomain.Account.DIRECT_SEARCH,
                    name: 'Domain Account Registration',
                    component: TheDomainAccountRegistPage,
                    meta: { can: 'directSearch DomainAccount' },
                },
                {
                    path: ScreenUrl.NodeDomain.Account.SHOW,
                    name: 'Domain Account Details',
                    component: TheDomainAccountDetailsPage,
                    meta: { can: 'show DomainAccount' },
                },
                {
                    path: ScreenUrl.NodeIdp.INDEX,
                    name: 'Node Idp List',
                    component: TheNodeIdpListPage,
                    meta: { can: 'search NodeIdp' },
                },
                {
                    path: ScreenUrl.NodeIdp.SHOW,
                    name: 'Node Idp Details',
                    component: TheNodeIdpDetailsPage,
                    meta: { can: 'show NodeIdp' },
                },
                {
                    path: ScreenUrl.NodeIdp.Account.DIRECT_SEARCH,
                    name: 'Idp Account Registration',
                    component: TheIdpAccountRegisterPage,
                    meta: { can: 'directSearch IdpAccount' },
                },
                {
                    path: ScreenUrl.NodeIdp.Account.SHOW,
                    name: 'Idp Account Details',
                    component: TheIdpAccountDetailsPage,
                    meta: { can: 'show IdpAccount' },
                },
                {
                    path: ScreenUrl.Node.INDEX,
                    name: 'Node List',
                    component: TheNodeListPage,
                    meta: { can: 'search Node' },
                },
                {
                    path: ScreenUrl.Node.SHOW,
                    name: 'Node Details',
                    component: TheNodeDetailsPage,
                    meta: { can: 'show Node' },
                },
                {
                    path: ScreenUrl.Node.OsAccount.DIRECT_SEARCH,
                    name: 'OS Account Addition',
                    component: TheOsAccountAdditionalPage,
                    meta: { can: 'directSearch NodeOsAccount' },
                },
                {
                    path: ScreenUrl.Node.OsAccount.SHOW,
                    name: 'OS Account Details',
                    component: TheOsAccountDetailsPage,
                    meta: { can: 'show NodeOsAccount' },
                },
                {
                    path: ScreenUrl.Node.OtherAccount.DIRECT_SEARCH,
                    name: 'Other Account Addition',
                    component: TheOtherAccountAdditionalPage,
                    meta: { can: 'directSearch NodeOsAccount' },
                },
                {
                    path: ScreenUrl.Node.OtherAccount.SHOW,
                    name: 'Other Account Details',
                    component: TheOtherAccountDetailsPage,
                    meta: { can: 'show NodeOtherAccount' },
                },
                {
                    path: ScreenUrl.NodeGroup.INDEX,
                    name: 'Node Group List',
                    component: TheNodeGroupListPage,
                    meta: { can: 'search NodeGroup' },
                },
                {
                    path: ScreenUrl.NodeGroup.SHOW,
                    name: 'Node Group Details',
                    component: TheNodeGroupDetailsPage,
                    meta: { can: 'show NodeGroup' },
                },
                {
                    path: ScreenUrl.SysPre.Server.SHOW,
                    name: 'System Preference Server Setting',
                    component: TheServerSettingPage,
                    meta: { can: 'show SystemSetting' },
                },
                {
                    path: ScreenUrl.SysPre.UserDomain.SHOW,
                    name: 'System Preference UserDomain Setting',
                    component: TheUserAuthenticateManagementPage,
                    meta: { can: 'show UserSetting' },
                },
                {
                    path: ScreenUrl.SysPre.Mail.SHOW,
                    name: 'System Preference Mail Setting',
                    component: TheMailSettingPage,
                    meta: { can: 'show MailSetting' },
                },
                {
                    path: ScreenUrl.MultifactorAuth.INDEX,
                    name: 'Multifactor Authentication List',
                    component: TheMultifactorAuthenticationListPage,
                    meta: { can: 'search MultifactorAuth', isRequiredMultifactor: true },
                },
                {
                    path: ScreenUrl.MultifactorAuth.SHOW,
                    name: 'Multifactor Authentication Details',
                    component: TheMultifactorAuthenticationDetailsPage,
                    meta: { can: 'show MultifactorAuth', isRequiredMultifactor: true },
                },
                {
                    path: ScreenUrl.SystemChangeHistory.INDEX,
                    name: 'System Change History List',
                    component: TheSystemChangeHistoryListPage,
                    meta: { can: 'search SystemChangeHistory' },
                },
                {
                    path: ScreenUrl.JobExecutionHistory.INDEX,
                    name: 'Job Execution History List',
                    component: TheJobExecutionHistoryListPage,
                    meta: { can: 'search JobExecutionHistory' },
                    props: true,
                },
                {
                    path: ScreenUrl.JobExecutionHistory.SHOW,
                    name: 'Job Execution Details',
                    component: TheJobExecutionDetailsPage,
                    meta: { can: 'show JobExecutionHistory' },
                },
                {
                    path: ScreenUrl.Csv.INDEX,
                    name: 'Csv',
                    component: TheCsvListPage,
                },
                {
                    path: ScreenUrl.DetectionRule.INDEX,
                    name: 'Detection Rule List',
                    component: TheDetectionRuleListPage,
                    meta: { can: 'search DetectionRule' },
                },
                {
                    path: ScreenUrl.DetectionRule.SHOW,
                    name: 'Detection Rule Details',
                    component: TheDetectionRuleDetailsPage,
                    meta: { can: 'show DetectionRule' },
                },
                {
                    path: ScreenUrl.DetectionRuleGroup.INDEX,
                    name: 'Detection Rule Group List',
                    component: TheDetectionRuleGroupListPage,
                    meta: { can: 'search DetectionRuleGroup' },
                },
                {
                    path: ScreenUrl.DetectionRuleGroup.SHOW,
                    name: 'Detection Rule Group Details',
                    component: TheDetectionRuleGroupDetailsPage,
                    meta: { can: 'show DetectionRuleGroup' },
                },
                {
                    path: ScreenUrl.Workflow.INDEX,
                    name: 'Workflow List',
                    component: TheWorkflowListPage,
                    meta: { can: 'search Workflow', isWorkflow: true },
                },
                {
                    path: ScreenUrl.Workflow.SHOW,
                    name: 'Workflow Details',
                    component: TheWorkflowDetailsPage,
                    meta: { can: 'show Workflow', isWorkflow: true },
                },
                {
                    path: ScreenUrl.BusinessSystem.INDEX,
                    name: 'Business System List',
                    component: TheBusinessSystemListPage,
                    meta: { can: 'search BusinessSystem' },
                },
                {
                    path: ScreenUrl.BusinessSystem.SHOW,
                    name: 'Business System Details',
                    component: TheBusinessSystemDetailsPage,
                    meta: { can: 'show BusinessSystem' },
                },
                {
                    path: ScreenUrl.BusinessSystem.ApplicationTemplate.DIRECT_SEARCH,
                    name: 'Application Template Create',
                    component: TheApplicationTemplateAdditionalPage,
                    meta: { can: 'directSearch ApplicationTemplate' },
                },
                {
                    path: ScreenUrl.BusinessSystem.ApplicationTemplate.SHOW,
                    name: 'Application Template Details',
                    component: TheApplicationTemplateDetailsPage,
                    meta: { can: 'show ApplicationTemplate' },
                },
                {
                    path: ScreenUrl.BusinessSystem.AccountSet.DIRECT_SEARCH,
                    name: 'Account Set Create',
                    component: TheAccountSetAdditionalPage,
                    meta: { can: 'directSearch AccountSet' },
                },
                {
                    path: ScreenUrl.BusinessSystem.AccountSet.SHOW,
                    name: 'Account Set Details',
                    component: TheAccountSetDetailsPage,
                    meta: { can: 'show AccountSet' },
                },
                {
                    path: ScreenUrl.BusinessSystem.RoutineWorkTemplate.DIRECT_SEARCH,
                    name: 'Routine Work Template Create',
                    component: TheRoutineWorkTemplateAdditionalPage,
                    meta: { can: 'directSearch RoutineWorkTemplate' },
                },
                {
                    path: ScreenUrl.BusinessSystem.RoutineWorkTemplate.SHOW,
                    name: 'Routine Work Template Details',
                    component: TheRoutineWorkTemplateDetailsPage,
                    meta: { can: 'show RoutineWorkTemplate' },
                },
                {
                    path: ScreenUrl.AutoLoginApp.INDEX,
                    name: 'Auto Login Application List',
                    component: TheAutoLoginApplicationListPage,
                    meta: { can: 'search AutoLoginApp' },
                },
                {
                    path: ScreenUrl.AutoLoginApp.SHOW,
                    name: 'Auto Login Application Details',
                    component: TheAutoLoginApplicationDetailsPage,
                    meta: { can: 'show AutoLoginApp' },
                },
                {
                    path: ScreenUrl.ApplicationFormTemplate.INDEX,
                    name: 'Application Form Template List',
                    component: TheApplicationFormTemplateListPage,
                    meta: { isRequiresWorkApplication: true },
                },
                {
                    path: ScreenUrl.ApplicationFormTemplate.ApplicationForm.CREATE_DETAILS,
                    name: 'Details Application Form Add',
                    component: TheDetailsApplicationFormAdditionalPage,
                    meta: { isRequiresWorkApplication: true },
                },
                {
                    path: ScreenUrl.ApplicationFormTemplate.ApplicationForm.CREATE_SIMPLE,
                    name: 'Simple Application Form Add',
                    component: TheSimpleApplicationFormAdditionalPage,
                    meta: { isRequiresWorkApplication: true },
                },
                {
                    path: ScreenUrl.ApplicationFormTemplate.COPY,
                    name: 'Details Application Form Copy',
                    component: TheCopyApplicationFormAdditionalPage,
                    meta: { isRequiresWorkApplication: true },
                },
                {
                    path: ScreenUrl.ApplicationForm.INDEX,
                    name: 'Application Form List',
                    component: TheApplicationFormListPage,
                    meta: { isApplicationForm: true },
                },
                {
                    path: ScreenUrl.ApplicationForm.SHOW,
                    name: 'Application Form Details',
                    component: TheApplicationFormDetailsPage,
                    meta: { isApplicationForm: true },
                },
                {
                    path: ScreenUrl.ApplicationForm.LendingRecord.INDEX1,
                    name: 'Application Form Lending Record List',
                    component: TheLendingRecordListPage,
                    meta: { isApplicationForm: true, isPrivilegeIdLendingRecord: true },
                },
                {
                    path: ScreenUrl.ApplicationForm.DetectionRulesRecords.DIRECT_SEARCH,
                    name: 'Application Form Detection Rules Record List',
                    component: TheApplicationFormDetectionRulesRecordListPage,
                    meta: { isApplicationForm: true },
                },
                {
                    path: ScreenUrl.WaitingApplication.INDEX,
                    name: 'Waiting Application List',
                    component: TheWaitingApplicationListPage,
                    meta: { isRequiresWorkApplication: true },
                },
                {
                    path: ScreenUrl.WaitingApplication.CREATE_DETAILS,
                    name: 'Waiting Details Application Form Add',
                    component: TheWaitingDetailsApplicationFormAdditionalPage,
                    meta: { isRequiresWorkApplication: true },
                },
                {
                    path: ScreenUrl.PrivilegedIdSetting.SHOW,
                    name: 'Application Management Number Registration',
                    component: ThePrivilegedIdSettingPage,
                    meta: { can: 'show AppManagementNumber' },
                },
                {
                    path: ScreenUrl.privilegeIdLendingRecord.INDEX,
                    name: 'Privilege Id Lending Record List',
                    component: ThePrivilegeIdLendingHistoryPage,
                    meta: { isPrivilegeIdLendingRecord: true },
                },
                {
                    path: ScreenUrl.privilegeIdLendingRecord.SHOW,
                    name: 'Privilege Id Lending Record Details',
                    component: ThePrivilegeIdLendingHistoryDetailsPage,
                    meta: { isPrivilegeIdLendingRecord: true },
                },
                {
                    path: ScreenUrl.DetectionRulesRecord.INDEX,
                    name: 'Detection Rules Record List',
                    component: TheDetectionRulesRecordListPage,
                    meta: { can: 'search DetectionRulesRecord' },
                },
                {
                    path: ScreenUrl.DetectionRulesRecord.SHOW,
                    name: 'Detection Rules Record Details',
                    component: TheDetectionRulesRecordDetailsPage,
                    meta: { can: 'show DetectionRulesRecord' },
                },
                {
                    path: ScreenUrl.LoginRecord.INDEX,
                    name: 'Login Record List',
                    component: TheLoginHistoryPage,
                    meta: { can: 'search LoginRecord' },
                },
                {
                    path: ScreenUrl.PersonalSetting.INDEX,
                    name: 'PersonalSetting',
                    component: ThePersonalSettingPage,
                },
                {
                    path: ScreenUrl.RecLinkageSetting.INDEX,
                    name: 'Rec Linkage Setting',
                    component: TheRecLinkageSettingPage,
                    meta: { can: 'show RecLinkageSetting', isRequiredRecLinkage: true },
                },
                {
                    path: ScreenUrl.License.INDEX,
                    name: 'License List',
                    component: TheLicenseListPage,
                    meta: { can: 'index License' },
                },
                {
                    path: ScreenUrl.License.SHOW,
                    name: 'License Details',
                    component: TheLicenseDetailsPage,
                    meta: { can: 'show License' },
                },
                {
                    path: ScreenUrl.ExternalProgramUsage.INDEX,
                    name: 'External Program Usage List',
                    component: TheExtarnalProgramUsageListPage,
                    meta: { can: 'index ExternalProgramUsage' },
                },
                {
                    path: ScreenUrl.ExternalProgramUsage.SHOW,
                    name: 'External Program Usage Details',
                    component: TheExternalProgramUsageDetailsPage,
                    meta: { can: 'show ExternalProgramUsage' },
                },
                {
                    path: ScreenUrl.LoginFailureRecord.INDEX,
                    name: 'Login Failure Record List',
                    component: TheLoginFailureHistoryPage,
                    meta: { can: 'search LoginFailureRecord' },
                },
                {
                    path: ScreenUrl.NodeLoginHistoryExcludeCondition.INDEX,
                    name: 'Node Login History Exclude Condition List',
                    component: TheNodeLoginHistoryExcludeConditionListPage,
                    meta: { can: 'search LoginFailureRecord' },
                },
                {
                    path: ScreenUrl.NodeLoginHistoryExcludeCondition.SHOW,
                    name: 'Node Login History Exclude Condition Details',
                    component: TheNodeLoginHistoryExcludeConditionDetailsPage,
                    meta: { can: 'show NodeLoginHistoryExcludeCondition' },
                },
                {
                    path: ScreenUrl.AccountInventoryResultDiff.INDEX,
                    name: 'Account Inventory Result Diff List',
                    component: TheAccountInventoryResultDiffListPage,
                    meta: { can: 'search AccountInventoryResultDiff' },
                },
                {
                    path: ScreenUrl.AccountInventoryResultDiff.SHOW,
                    name: 'Account Inventory Result Diff Details',
                    component: TheAccountInventoryResultDiffDetailsPage,
                    meta: { can: 'show AccountInventoryResultDiff' },
                },
                {
                    path: ScreenUrl.AccountInventorySetting.INDEX,
                    name: 'Account Inventory Setting List',
                    component: TheAccountInventorySettingListPage,
                    meta: { can: 'search AccountInventorySetting' },
                },
                {
                    path: ScreenUrl.AccountInventorySetting.SHOW,
                    name: 'Account Inventory Setting Details',
                    component: TheAccountInventorySettingDetailsPage,
                    meta: { can: 'show AccountInventorySetting' },
                },
                {
                    path: ScreenUrl.AccountInventoryResult.INDEX,
                    name: 'Account Inventory Result List',
                    component: TheAccountInventoryResultListPage,
                    meta: { can: 'search AccountInventoryResult' },
                },
                {
                    path: ScreenUrl.AccountInventoryResult.SHOW,
                    name: 'Account Inventory Result Details',
                    component: TheAccountInventoryResultDetailsPage,
                    meta: { can: 'show AccountInventoryResult' },
                },
            ],
        },
        {
            path: ScreenUrl.Auth.SAML_OA,
            component: TheLoginWaitingPageLayout,
            children: [
                {
                    path: ScreenUrl.Auth.SAML_OA,
                    name: 'Login Waiting Page',
                    component: TheSamlLoginWaitingPage,
                    meta: { isOaHook: true },
                },
            ],
        },
        {
            path: ScreenUrl.Auth.SAML_OAFB,
            component: TheLoginWaitingPageLayout,
            children: [
                {
                    path: ScreenUrl.Auth.SAML_OAFB,
                    name: 'Login Waiting Page',
                    component: TheSamlLoginWaitingPage,
                    meta: { isOafbHook: true },
                },
            ],
        },
        {
            path: ScreenUrl.Auth.SAML_VERIFY,
            component: TheLoginWaitingPageLayout,
            children: [
                {
                    path: ScreenUrl.Auth.SAML_VERIFY,
                    name: 'SAML Verifying Page',
                    component: TheSamlVerifyPage,
                    meta: { requiresBeforeAuth: true },
                },
            ],
        },
        {
            path: ScreenUrl.Auth.NODE_SAML_LOGIN,
            component: TheNodeSamlLoginPageLayout,
            children: [
                {
                    path: ScreenUrl.Auth.NODE_SAML_LOGIN,
                    name: 'Node SAML Login Page',
                    component: TheNodeSamlLoginPage,
                    meta: { requiresBeforeAuth: true, nodeSamlLogin: true },
                },
            ],
        },
        {
            path: ScreenUrl.NodeSaml.BEFORE,
            component: TheNodeSamlBeforePageLayout,
            meta: { requiresAuth: true },
            children: [
                {
                    path: ScreenUrl.NodeSaml.BEFORE,
                    name: 'Before Node SAML Work List Page',
                    component: TheNodeSamlBeforeWorkListPage,
                    meta: { nodeSamlWorkList: true },
                },
            ],
        },
        {
            path: ScreenUrl.NodeSaml.INDEX,
            component: TheNodeSamlPageLayout,
            meta: { requiresAuth: true },
            children: [
                {
                    path: ScreenUrl.NodeSaml.INDEX,
                    name: 'Node SAML Work List Page',
                    component: TheNodeSamlWorkListPage,
                    meta: { nodeSamlWorkList: true },
                },
                {
                    path: ScreenUrl.NodeSaml.ERROR,
                    name: 'Node SAML Work List Error Page',
                    component: TheNodeSamlWorkListErrorPage,
                    meta: { nodeSamlWorkList: true },
                },
            ],
        },
    ],
};

const authGard = async (to, from, next) => {
    const isRequiresAuthPath: boolean = to.matched.some(record => record.meta.requiresAuth);
    const isRequiresBeforeAuthPath: boolean = to.matched.some(record => record.meta.requiresBeforeAuth);
    const isChangesPasswordPath: boolean = to.matched.some(record => record.meta.passwordChange);
    const isRecLinkageSettingsPath: boolean = to.matched.some(record => record.meta.isRequiredRecLinkage);
    const isApplicationFormTemplatePath: boolean = to.matched.some(record => record.meta.isRequiresWorkApplication);
    const isApplicationFormPath: boolean = to.matched.some(record => record.meta.isApplicationForm);
    const isMultifactorPath: boolean = to.matched.some(record => record.meta.isRequiredMultifactor);
    const isWorkflowPath: boolean = to.matched.some(record => record.meta.isWorkflow);
    const isPrivilegeIdLendingRecordPath: boolean = to.matched.some(record => record.meta.isPrivilegeIdLendingRecord);
    const isOaHookPath: boolean = to.matched.some(record => record.meta.isOaHook);
    const isOafbHookPath: boolean = to.matched.some(record => record.meta.isOafbHook);
    const isNodeSamlLoginPath: boolean = to.matched.some(record => record.meta.nodeSamlLogin);
    const isNodeSamlWorkListPath: boolean = to.matched.some(record => record.meta.nodeSamlWorkList);

    if (isOaHookPath || isOafbHookPath) {
        next();
        return;
    }

    const amIAuthed = store.getters['auth/amIAuthed']();
    let myAuthorities = store.getters['auth/authorities']();
    let activeData = store.getters['license/active']();
    let templateCount = store.getters['applicationFormTemplate/count']();
    let userSetting = store.getters['userSetting/userSetting']();
    let lendingRecordDisplayable = store.getters['privilegeIdLendingRecord/displayable']();
    let nodeSamlLogin = store.getters['auth/nodeSaml/samlSession']();

    // 認証済みなのに未だ権限リストを取得していない場合は事前に取得する
    if (amIAuthed && !myAuthorities) {
        if (!isNodeSamlLoginPath) {
            await store.dispatch('auth/myAuthorities');
        } else {
            await store.dispatch('auth/clearAuthData'); // SAMLログイン画面の場合は改めて認証するので取得は不要
        }
    }
    if (amIAuthed && isRequiresAuthPath && !activeData) {
        await store.dispatch('license/active');
        activeData = store.getters['license/active']();
    }
    if (amIAuthed && isRequiresAuthPath && !templateCount) {
        await store.dispatch('applicationFormTemplate/count');
        templateCount = store.getters['applicationFormTemplate/count']();
    }
    if (amIAuthed && isRequiresAuthPath && !userSetting) {
        await store.dispatch('userSetting/show');
        userSetting = store.getters['userSetting/userSetting']();
    }
    if (amIAuthed && isPrivilegeIdLendingRecordPath && !lendingRecordDisplayable) {
        await store.dispatch('privilegeIdLendingRecord/displayable');
        lendingRecordDisplayable = store.getters['privilegeIdLendingRecord/displayable']();
    }

    if (!amIAuthed && isChangesPasswordPath && to.query.token) {
        // パスワードを忘れた場合のパスワード変更ページ
        next();
    } else if (!isRequiresBeforeAuthPath && !amIAuthed && !isChangesPasswordPath) {
        // 未認証で存在しないページにアクセスしようとした場合はログイン画面に強制遷移
        next({
            path: ScreenUrl.Auth.LOGIN,
            query: { redirect: to.fullPath },
        });
    } else if (!amIAuthed && isChangesPasswordPath) {
        // パスワード更新画面で何もせずに画面を更新した場合ログイン画面に強制遷移
        next({ path: ScreenUrl.Auth.LOGIN });
    } else if (amIAuthed && isNodeSamlLoginPath) {
        // 認証済みの場合も、SAML連携ログイン画面へは一旦移動させる
        // ロジックの都合上、コンポーネント側で作業一覧ページへの強制遷移を行う
        next();
    } else if (amIAuthed && !isNodeSamlWorkListPath && nodeSamlLogin) {
        // SAML連携ログイン処理中の場合は作業一覧ページに強制遷移
        next({ path: ScreenUrl.NodeSaml.BEFORE });
    } else if (!isRequiresAuthPath && amIAuthed && !isChangesPasswordPath) {
        // 認証済みで存在しないページにアクセスしようとした場合はTOP画面に強制遷移
        next({ path: ScreenUrl.TOP });
    } else if (isRecLinkageSettingsPath && activeData.pim.edition != 'enterprise') {
        // ライセンスがエンタプライズ以外 かつ REC連携設定ページにアクセスしようとした場合はTOP画面に強制遷移
        next({ path: ScreenUrl.TOP });
    } else if (isApplicationFormTemplatePath && templateCount <= 0) {
        // ログインユーザーと申請可能な申請書テンプレート件数がない かつ 作業申請系にアクセスしようとした場合はTOP画面に強制遷移する
        next({ path: ScreenUrl.TOP });
    } else if (isWorkflowPath && activeData.pim.edition === 'lite') {
        // ライセンスがライト かつ ワークフロー系にアクセスしようとした場合はTOP画面に強制遷移する
        next({ path: ScreenUrl.TOP });
    } else if (isApplicationFormTemplatePath && activeData.pim.edition === 'lite') {
        // ライセンスがライト かつ 作業申請系にアクセスしようとした場合はTOP画面に強制遷移する
        next({ path: ScreenUrl.TOP });
    } else if (isApplicationFormPath && activeData.pim.edition === 'lite') {
        // ライセンスがライト かつ 申請書系にアクセスしようとした場合はTOP画面に強制遷移する
        next({ path: ScreenUrl.TOP });
    } else if (isMultifactorPath && userSetting.multifactor.status == 'no') {
        // 多要素認証情報の利用可否が利用しない かつ 多要素認証デバイス管理系にアクセスしようとした場合はTOP画面に強制遷移する
        next({ path: ScreenUrl.TOP });
    } else if (isPrivilegeIdLendingRecordPath && !lendingRecordDisplayable) {
        // 特権ID貸出履歴の参照権限がない かつ 特権ID貸出履歴・記録系にアクセスしようとした場合はTOP画面に強制遷移する
        next({ path: ScreenUrl.TOP });
    } else {
        // その他正常な画面遷移
        next();
    }
};

const clearStores = async (to, from) => {
    const names = Object.keys(modules).map(key => `${key}/clearOnBeforeRoute`);
    await Promise.all(names.map(n => store.dispatch(n)));
};

export { routes, authGard, clearStores };
